import ListC52020Controls from "./C52020/list";
import ListC52020Versions from "./C52020/versions";

import ListDORAControls from "./DORA/list";
import ListDORAVersions from "./DORA/versions";

import ListISO27001Controls from "./ISO27001/list";
import ListISO27001Versions from "./ISO27001/versions";

import ListISO42001Controls from "./ISO42001/list";
import ListISO42001Versions from "./ISO42001/versions";

import ListNIS2Controls from "./NIS2/list";
import ListNIS2Versions from "./NIS2/versions";

import ListTISAXControls from "./TISAX/list";
import ListTISAXVersions from "./TISAX/versions";

const Framewoks = {
    "C5_2020": {
        list: (props) => <ListC52020Controls {...props} />,
        versions: (props) => <ListC52020Versions {...props} />
    },
    "DORA": {
        list: (props) => <ListDORAControls {...props} />,
        versions: (props) => <ListDORAVersions {...props} />
    },
    "ISO27001": {
        list: (props) => <ListISO27001Controls {...props} />,
        versions: (props) => <ListISO27001Versions {...props} />
    },
    "ISO42001": {
        list: (props) => <ListISO42001Controls {...props} />,
        versions: (props) => <ListISO42001Versions {...props} />
    },
    "NIS2": {
        list: (props) => <ListNIS2Controls {...props} />,
        versions: (props) => <ListNIS2Versions {...props} />
    },
    "TISAX": {
        list: (props) => <ListTISAXControls {...props} />,
        versions: (props) => <ListTISAXVersions {...props} />
    }, 
}

const FrameworkHandler = ({ frameworkKey, section, ...props }) => {
    const FrameworkComponent = Framewoks[frameworkKey]?.[section];

    if (!FrameworkComponent) return null;

    return (
        <FrameworkComponent
            {...props}
        />
    )
}

export default FrameworkHandler;